import { defineMessages } from "react-intl";

export const teamsWizardMessages = defineMessages({
  wizardTitle: {
    defaultMessage: "Add Teams Communication Channel",
    id: "teamsWizardMessages.wizardTitle",
  },

  configureMicrosoftTeams: {
    defaultMessage: "Configure Microsoft Teams",
    id: "teamsWizardMessages.configureMicrosoftTeams",
  },

  changeCredTitle: {
    defaultMessage: "Change credential",
    id: "teamsWizardMessages.changeCredTitle",
  },

  changeCredential: {
    defaultMessage: "Credential changed to user account",
    id: "teamsWizardMessages.changeCredential",
  },

  configureRecipientsMicrosoftTeams: {
    defaultMessage: "Configure recipients for Microsoft Teams",
    id: "teamsWizardMessages.configureRecipientsMicrosoftTeams",
  },

  teamField: {
    defaultMessage: "Team",
    id: "teamsWizardMessages.teamField",
  },

  channelField: {
    defaultMessage: "Channel",
    id: "teamsWizardMessages.channelField",
  },

  mentionTeam: {
    defaultMessage: "Mention team",
    id: "teamsWizardMessages.mentionTeam",
  },

  mentionChannel: {
    defaultMessage: "Mention channel",
    id: "teamsWizardMessages.mentionChannel",
  },

  channelName: {
    defaultMessage: "Channel name",
    id: "teamsWizardMessages.channelName",
  },

  description: {
    defaultMessage: "Description",
    id: "teamsWizardMessages.description",
  },

  userAccount: {
    defaultMessage: "User account",
    id: "teamsWizardMessages.userAccount",
  },

  mSTeamsSender: {
    defaultMessage: "MS Teams sender",
    id: "exchangeOnlineWizardMessages.mSTeamsSender",
  },

  teamToNotify: {
    defaultMessage: "Team to notify",
    id: "exchangeOnlineWizardMessages.teamToNotify",
  },

  channelToNotify: {
    defaultMessage: "Channel to notify",
    id: "exchangeOnlineWizardMessages.channelToNotify",
  },
});
